import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import {
    fetchAssignmentsByJob, assignToJob, unassign,
} from '../api/jobAssignmentsApi';

// Per-job assigned-crew list. Used by JobAssignmentsCard on the job detail
// page (Manager+ surface).
export function useJobAssignments(jobId) {
    return useQuery({
        queryKey: ['jobAssignments', jobId],
        queryFn: () => fetchAssignmentsByJob(jobId),
        enabled: !!jobId,
    });
}

export function useAssignToJob(jobId) {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (userId) => assignToJob(jobId, userId),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['jobAssignments', jobId] });
        },
    });
}

export function useUnassign(jobId) {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (assignmentId) => unassign(assignmentId),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['jobAssignments', jobId] });
        },
    });
}
